module.exports = __webpack_public_path__ + "static/img/10zhidaole.75b74f74.gif";